import { splitProps, createRenderEffect, onCleanup } from 'solid-js';
import { isServer, spread } from 'solid-js/web';

// src/index.ts
var OMITTED_PROPS = ["src"];
function createScriptLoader(props) {
  if (isServer) {
    return void 0;
  }
  const script = document.createElement("script");
  const [local, scriptProps] = splitProps(props, OMITTED_PROPS);
  setTimeout(() => spread(script, scriptProps, false, true));
  createRenderEffect(() => {
    const src = typeof local.src === "string" ? local.src : local.src();
    const prop = /^(https?:|\w[\.\w-_%]+|)\//.test(src) ? "src" : "textContent";
    if (script[prop] !== src) {
      script[prop] = src;
      document.head.appendChild(script);
    }
  });
  onCleanup(() => document.head.contains(script) && document.head.removeChild(script));
  return script;
}

export { createScriptLoader };
